import moment from 'moment';
import pdfMake from 'pdfmake/build/pdfmake.js';
import getImage from './../../../ClinicHistory/ClinicEvent/components/PdfReports/GetImage';
import ReportsAPI from './../../api/reports_api';

const OperationDiaryPDF = async (obj) => {
    pdfMake.fonts = {
        OpenSans: {
            normal: 'OpenSans-Regular.ttf',
            bold: 'OpenSans-Bold.ttf',
            italics: 'OpenSans-Italic.ttf',
            bolditalics: 'OpenSans-ExtraBoldItalic.ttf'
        },
        Merriweather: {
            normal: 'Merriweather-Regular.ttf',
            bold: 'Merriweather-Bold.ttf',
            italics: 'Merriweather-Italic.ttf',
            bolditalics: 'Merriweather-ExtraBoldItalic.ttf'
        },
        Roboto: {
            normal: 'Roboto-Regular.ttf',
            bold: 'Roboto-Bold.ttf',
            italics: 'Roboto-Italic.ttf',
            bolditalics: 'Roboto-BoldItalic.ttf'
        }
    };

    console.log("COMINGTOPDF", obj)
    //const city = obj.profile.direccion.id_ciudad;
    const city = sessionStorage.getItem('id_ciudad');
    const getCity = await
        ReportsAPI.loadCity(city);
    console.log("StoresCioudad", city)
    console.log("CIUDADPDF", getCity);

    let cityReport= getCity.length > 0 ? getCity[0].ciunom : ' ';

    const getRandomInt = (min, max) => {
        return Math.floor(Math.random() * (max - min)) + min;
    }

    let randomReport = getRandomInt(110, 1);
    let itemBodyFontSize = 6;

    //Tabla de Contenido
    let itemBody = [
        [
            {
                text: "RC",
                style: "tableHeader",
                alignment: "center",
                fontSize: itemBodyFontSize
            },
            {
                text: "Hora",
                style: "tableHeader",
                alignment: "center",
                fontSize: itemBodyFontSize
            },
            {
                text: "Nombre y Apellido",
                style: "tableHeader",
                alignment: "center",
                fontSize: itemBodyFontSize
            },
            {
                text: "Edad",
                style: "tableHeader",
                alignment: "center",
                fontSize: itemBodyFontSize
            },
            {
                text: "Examen",
                style: "tableHeader",
                alignment: "center",
                fontSize: itemBodyFontSize
            },
            {
                text: "Embarazo",
                style: "tableHeader",
                alignment: "center",
                fontSize: itemBodyFontSize
            },
            {
                text: "Diagnostico",
                style: "tableHeader",
                alignment: "center",
                fontSize: itemBodyFontSize
            },
            {
                text: "Talla (CM)",
                style: "tableHeader",
                alignment: "center",
                fontSize: itemBodyFontSize
            },
            {
                text: "Peso (Kg)",
                style: "tableHeader",
                alignment: "center",
                fontSize: itemBodyFontSize
            },
            {
                text: "Dosis prescrita (Mbq)",
                style: "tableHeader",
                alignment: "center",
                fontSize: itemBodyFontSize
            },
            {
                text: "Dosis Administrada (Mbq)",
                style: "tableHeader",
                alignment: "center",
                fontSize: itemBodyFontSize
            },
            {
                text: "Vo Bo. Medico Nuclear",
                style: "tableHeader",
                alignment: "center",
                fontSize: itemBodyFontSize
            },
            {
                text: "Verificación (Venc. Fármaco Jeringa)",
                style: "tableHeader",
                alignment: "center",
                fontSize: itemBodyFontSize
            }
        ],
    ];
    let itemArr = ["", "", "", "", "", "", "", "", "", "", "", "", ""];
    if (obj.items.length === 0) itemBody.push(itemArr);
    for (let index = 0; index < obj.items.length; index++) {
        const element = obj.items[index];
        let edadString = "";
        switch (element.unidad_medida_edad) {
            case 1: //Años
                edadString = element.edad.toString() + "A";
                break;
            case 2: //Meses
                edadString = element.edad.toString() + "M";
                break;
            case 3: //Dias
                edadString = element.edad.toString() + "D";
                break;
        }
        itemBody.push([
            { text: element.tip_documento + "-" + element.num_documento, alignment: "center" },
            { text: element.hora, alignment: "center" },
            { text: element.nombre_paciente, alignment: "center" },
            { text: edadString, alignment: "center" },
            { text: element.servicio.servicios[0].nombre, alignment: "center" },
            { text: element.embarazo, alignment: "center" },
            { text: element.diagnostico, alignment: "center" },
            { text: element.talla, alignment: "center" },
            { text: element.peso, alignment: "center" },
            { text: element.dosis_prescrita, alignment: "center" },
            { text: element.dosis_suministrada, alignment: "center" },
            { text: element.vbo_medico_nuclear, alignment: "center" },
            { text: element.verificacion_farmaco_jeringa, alignment: "center" }
        ]);
    }

    pdfMake.tableLayouts = {
        exampleLayout: {
            hLineWidth: function (i, node) {
                if (i === 0 || i === node.table.body.length) {
                    return 1;
                }
                return i === node.table.headerRows ? 2 : 1;
            },
            vLineWidth: function (i) {
                return 1;
            },
            hLineColor: function (i, node) {
                if (i === 0 || i === node.table.body.length) {
                    return "black";
                }
                return i === 1 ? "black" : "#aaa";
            },
            fillColor: function (i, node) {
                return i === 0 ? "white" : i % 2 === 0 ? "#e8e8e8" : null;
            },
            paddingLeft: function (i) {
                return i === 0 ? 8 : 8;
            },
            paddingRight: function (i, node) {
                //return i === node.table.widths.length - 1 ? 0 : 8;
                return 3;
            },
            paddingTop: function (i, node) {
                return 3;
            },
            paddingBottom: function (i, node) {
                return 3;
            },

        },
    };

    const header = {
        margin: [40, 10, 0, 0],
        layout: 'noBorders',
        table: {
            widths: ['*', '*', '*'],
            body: [
                [
                    {
                        /* image: await getImage(data.urlLogo),
                        fit: [100, 40], */
                        image: await getBase64ImageFromURL(process.env.REACT_APP_PUBLIC_URL + "clinica/" + obj.profile.id_clinica + "/logo/" + sessionStorage.getItem('token')),
                        fit: [180, 90],
                    },
                    {
                        width: "auto",
                        text: [
                            {
                                text: obj.profile.nombre + "\n" +
                                    "NIT:" + obj.profile.nit + "\n" +
                                    obj.profile.direccion.direccion + "\n"
                                    + obj.profile.telefono1 + "\n" +
                                    obj.profile.email
                            },
                        ],
                        alignment: "center"
                    },
                    {
                        text: [
                            {
                                text: obj.title,
                                bold: true,
                                width: "auto",
                                alignment: "left",
                                lineHeight: 1.2,
                                fontSize: 15,
                            },
                            {
                                text: "\n"
                            },
                            {
                                text: "CÓDIGO: FT. IM - " + randomReport,
                                width: "auto",
                                alignment: "left",
                                lineHeight: 1.2,
                                fontSize: 7.5,
                            },
                            {
                                text: "\n"
                            },
                            {
                                text: 'CREACIÓN: ' + moment(new Date()).format('DD/MM/YYYY'),
                                width: "auto",
                                alignment: "left",
                                lineHeight: 1.2,
                                fontSize: 7.5,
                            },
                            {
                                text: "\n"
                            },
                            {
                                text: "VERSIÓN: 1",
                                width: "auto",
                                alignment: "left",
                                lineHeight: 1.2,
                                fontSize: 7.5,
                            },

                            {
                                text: "\n"
                            },
                            {
                                text: "PAGINA: 1 DE 1",
                                width: "auto",
                                alignment: "left",
                                lineHeight: 1.2,
                                fontSize: 7.5,
                            }
                        ]

                    },
                ]
            ]
        },
    };

    var docDefinition = {
        pageSize: "LETTER",
        pageOrientation: "landscape",
        info: {
            title: obj.title,
            author: "",
        },
        /*footer: function (currentPage, pageCount, pageSize) {
            return [
                {
                    canvas: [
                        {
                            type: "rect",
                            x: 0,
                            y: 0,
                            w: pageSize.width,
                            h: 5,
                        },

                    ],
                }
            ];
        },*/

        /* header: header,
 */
        content: [
            {

                columns: [
                    {
                        width: 300,
                        columns: [
                            {
                                image: await getBase64ImageFromURL(process.env.REACT_APP_PUBLIC_URL + "clinica/" + obj.profile.id_clinica + "/logo/" + sessionStorage.getItem('token')),
                                fit: [180, 90],
                            },
                        ],
                    },
                    {
                        width: "auto",
                        text: [
                            {
                                text: obj.profile.nombre + "\n" +
                                    "NIT:" + obj.profile.nit + "\n" +
                                    obj.profile.direccion.direccion + "\n"
                                    + obj.profile.telefono1 + "\n" +
                                    obj.profile.email
                            },
                        ],
                        alignment: "center"
                    },
                    {
                        text: [
                            {
                                text: obj.title,
                                bold: true,
                                width: "auto",
                                alignment: "left",
                                lineHeight: 1.2,
                                fontSize: 15,
                            },
                            {
                                text: "\n"
                            },
                            {
                                text: "CÓDIGO: FT. IM - " + randomReport,
                                width: "auto",
                                alignment: "left",
                                lineHeight: 1.2,
                                fontSize: 7.5,
                            },
                            {
                                text: "\n"
                            },
                            {
                                text: 'CREACIÓN: 24/08/2019',
                                width: "auto",
                                alignment: "left",
                                lineHeight: 1.2,
                                fontSize: 7.5,
                            },
                            {
                                text: "\n"
                            },
                            {
                                text: "VERSIÓN: 1",
                                width: "auto",
                                alignment: "left",
                                lineHeight: 1.2,
                                fontSize: 7.5,
                            },

                            {
                                text: "\n"
                            },
                            {
                                text: "PAGINA: 1 DE 1",
                                width: "auto",
                                alignment: "left",
                                lineHeight: 1.2,
                                fontSize: 7.5,
                            }
                        ]

                    },
                ],
            },
            {
                text: 'LUGAR Y FECHA: ' +  cityReport + ', ' + moment(obj.finalDate).format('DD/MM/YYYY'),
                fontSize: 10
            },
            {
                style: "tableExample",
                table: {
                    headerRows: 1,
                    widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto',],
                    //keepWithHeaderRows: 1,
                    body: itemBody,
                },
                layout: "exampleLayout",
                dontBreakRows: true,
            },
        ],
        styles: {
            header: {
                fontSize: 18,
                bold: true,
                margin: [0, 0, 0, 10],
            },
            subheader: {
                fontSize: 16,
                bold: true,
                margin: [0, 10, 0, 5],
            },
            tableExample: {
                margin: [0, 5, 0, 0],
                fontSize: itemBodyFontSize
            },
            tableHeader: {
                bold: true,
                fontSize: 9,
                color: "black",
            },
        },
        defaultStyle: {
            columnGap: 15,
        },
    };

    const pdfDocGenerator = pdfMake.createPdf(docDefinition);
    pdfDocGenerator.getDataUrl(function (outDoc) {
        document.getElementById('pdfV').src = outDoc;
    });
};

const getBase64ImageFromURL = (url) => {
    return new Promise((resolve, reject) => {
        var img = new Image();
        img.setAttribute("crossOrigin", "anonymous");

        img.onload = () => {
            var canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;

            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);

            var dataURL = canvas.toDataURL("image/png");

            resolve(dataURL);
        };

        img.onerror = error => {
            reject(error);
        };

        img.src = url;
    });
}

export default OperationDiaryPDF;